import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { useState } from "react";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { urlUtility } from "@repo/utilities/url.utility.ts";
import { IGetAllServiceProps } from "@api/types/globalService.types";
interface IPlanPolicyIGetServiceProps extends IGetAllServiceProps {
  page?: string;
  per_page?: string;
  enableQuery?: boolean;
  withParent?: boolean;
  filters?: Record<string, string>;
}

export const useGetAllAccountsService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
  withParent = false,
  filters = {},
}: IPlanPolicyIGetServiceProps) => {
  const urlQueries = urlUtility.getUrlQueries(location.search);
  const partnerId = urlQueries["partner_id"] || urlQueries["partner-id"];
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const created_between = urlQueries["created_between"] || "";
  const allAccountsService = useQuery({
    queryKey: [
      ...CACHE_KEYS.ACCOUNTS,
      debouncedQuery,
      page,
      per_page,
      created_between,
      partnerId,
      ...Object.values(filters),
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.ACCOUNTS,
        searchParams: {
          page,
          "filter[name]": debouncedQuery,
          "filter[created_between]": created_between,
          ...(withParent
            ? {
                "filter[partner_id_with_parent]": partnerId,
              }
            : partnerId
              ? { "filter[partner_id]": partnerId }
              : {}),
          ...filters,
          per_page,
          include: "partner,payment_modes,insurer",
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { allAccountsService },
    states: { searchQuery, setSearchQuery },
  };
};
